import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#49454F",
		d: "m16.128 17.352 1.4-1.4-3.7-3.7v-4.6h-2v5.4l4.3 4.3Zm-3.3 5.3a9.738 9.738 0 0 1-3.9-.787 10.099 10.099 0 0 1-3.175-2.138c-.9-.9-1.612-1.958-2.137-3.175a9.737 9.737 0 0 1-.788-3.9c0-1.383.263-2.683.788-3.9a10.098 10.098 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137a9.738 9.738 0 0 1 3.9-.788c1.383 0 2.684.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.959 2.138 3.175a9.737 9.737 0 0 1 .787 3.9 9.737 9.737 0 0 1-.787 3.9 10.098 10.098 0 0 1-2.138 3.175c-.9.9-1.958 1.613-3.175 2.138a9.737 9.737 0 0 1-3.9.787Zm0-2c2.217 0 4.104-.779 5.663-2.337 1.558-1.559 2.337-3.446 2.337-5.663 0-2.216-.779-4.104-2.337-5.662-1.559-1.558-3.446-2.338-5.663-2.338-2.216 0-4.104.78-5.662 2.338-1.559 1.558-2.338 3.446-2.338 5.662 0 2.217.78 4.104 2.338 5.663 1.558 1.558 3.445 2.337 5.662 2.337Z"
	})
});
export { SvgClock as ReactComponent };
